import { useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import InputForm from "components/agro/inputs/InputForm";
import demoInputs from "config/demo/inputs.json";

const InputUpdateForm = ({ inputId, onSuccess }) => {
  const [input] = useState(demoInputs.find((inp) => inp.id === inputId));

  async function onSubmit(valuesParam) {
    if (onSuccess) onSuccess();
  }

  if (!input) return <Loader />;

  return (
    <div>
      <InputForm onSubmit={onSubmit} type="update" initialValues={input} />
    </div>
  );
};

export default InputUpdateForm;
